export default __webpack_public_path__ + "static/media/denise.4406c53f.jpg";